import { render } from "./DataVisualization.vue?vue&type=template&id=361eb79c&scoped=true"
import script from "./DataVisualization.vue?vue&type=script&lang=js"
export * from "./DataVisualization.vue?vue&type=script&lang=js"

import "./DataVisualization.vue?vue&type=style&index=0&id=361eb79c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361eb79c"]])

export default __exports__